import "@pro/assets/scss/App.scss";

import { Routing } from "@common/_constants";
import { getUserFromStorage, TelemetryService } from "@common/_services";
import { UserFromStorage } from "@common/models";
import PrivateRoute from "@pro/components/Atoms/PrivateRoute";
import PublicRoute from "@pro/components/Atoms/PublicRoute";
import { Application } from "@pro/containers/Pages/Application";
import {
    ApplicationActivities,
} from "@pro/containers/Pages/ApplicationActivities";
import { Applications } from "@pro/containers/Pages/Applications";
import { ErrorNotFound } from "@pro/containers/Pages/ErrorNotFound";
import ErrorUnhandled from "@pro/containers/Pages/ErrorUnhandled";
import { Friends } from "@pro/containers/Pages/Friends";
import { Home } from "@pro/containers/Pages/Home";
import { Job } from "@pro/containers/Pages/Job";
import { Jobs } from "@pro/containers/Pages/Jobs";
import { Messages } from "@pro/containers/Pages/Messages";
import { Referral } from "@pro/containers/Pages/Referral";
import { ReferralActivities } from "@pro/containers/Pages/ReferralActivities";
import { Referrals } from "@pro/containers/Pages/Referrals";
import { Settings } from "@pro/containers/Pages/Settings";
import { UserActivity } from "@pro/containers/Pages/UserActivity";
import * as React from "react";
import { AnimatedSwitch } from "react-router-transition";

// route components
export class App extends React.Component<any> {
    loggedInUser?: UserFromStorage;

    componentDidMount() {
        const user = getUserFromStorage();
        if (
            !!this.loggedInUser &&
            !!user &&
            this.loggedInUser.token === user.token &&
            !!this.loggedInUser.token
        ) {
            // do nothing because this user has already logged in for this session.
            return;
        }

        this.loggedInUser = user;
        if (user) {
            TelemetryService.userLogin({
                email: user.email || "",
                applicationName: user.applicationName,
                fullName: user.displayName,
                roleId: user.roleId,
            });
        }
    }

    render() {
        return (
            <AnimatedSwitch
                atEnter={{ opacity: 0 }}
                atLeave={{ opacity: 0 }}
                atActive={{ opacity: 1 }}
                className="switch-wrapper"
                runOnMount={true}
            >
                <PrivateRoute exact={true} path="/" component={Home} />
                <PrivateRoute path="/index.html" component={Home} />
                <PrivateRoute
                    exact={true}
                    path={Routing.Client.Pro.Jobs.SEARCH}
                    component={Jobs}
                />
                <PrivateRoute
                    exact={true}
                    path={Routing.Client.Pro.Jobs.DETAILS}
                    component={Job}
                />
                <PrivateRoute
                    exact={true}
                    path={Routing.Client.Pro.Applications.DETAILS}
                    component={Application}
                />
                <PrivateRoute
                    exact={true}
                    path={Routing.Client.Pro.Applications.SEARCH}
                    component={Applications}
                />
                <PrivateRoute
                    exact={true}
                    path={Routing.Client.Pro.Applications.ACTIVITY}
                    component={ApplicationActivities}
                />
                <PrivateRoute
                    exact={true}
                    path={Routing.Client.Pro.Referrals.SEARCH}
                    component={Referrals}
                />
                <PrivateRoute
                    exact={true}
                    path={Routing.Client.Pro.Referrals.DETAILS}
                    component={Referral}
                />
                <PrivateRoute
                    exact={true}
                    path={Routing.Client.Pro.Referrals.ACTIVITY}
                    component={ReferralActivities}
                />
                <PrivateRoute
                    exact={true}
                    path={Routing.Client.Pro.Referrals.DETAILS_BY_USER_AND_JOB}
                    component={Referral}
                />
                <PrivateRoute
                    exact={true}
                    path={Routing.Client.Pro.Messages.SEARCH}
                    component={Messages}
                />
                <PrivateRoute
                    exact={true}
                    path={Routing.Client.Pro.Profile.ACTIVITY}
                    component={UserActivity}
                />
                <PrivateRoute
                    exact={true}
                    path={Routing.Client.Pro.Profile.FRIENDS}
                    component={Friends}
                />
                <PrivateRoute
                    exact={true}
                    path={Routing.Client.Pro.Profile.SETTINGS_PANE}
                    component={Settings}
                />
                <PublicRoute
                    path={Routing.Client.Pro.Error.OOPS}
                    component={ErrorUnhandled}
                />
                <PublicRoute
                    path={Routing.Client.Pro.Error.NOT_FOUND}
                    component={ErrorNotFound} 
                />
            </AnimatedSwitch>
        );
    }
}
